if (!customElements.get('quickbuy-variant-radios')) {
  customElements.define(
    'quickbuy-variant-radios',
    class QuickBuyVariantRadios extends VariantSelects {
      constructor() {
        super()

        this.dataset.updateUrl = false
        this.dataset.updateSwatch = false
        this.dataset.updateVariantTitle = true

        this.setupShowMoreButton()
      }

      onVariantChange() {
        this.updateOptions()
        this.updateMasterId()
        this.toggleAddButton(true, '', false)
        this.updatePickupAvailability()
        this.removeErrorMessage()
        this.updateVariantStatuses()

        if (!this.currentVariant) {
          this.toggleAddButton(true, '', true)
          this.setUnavailable()
        } else {
          this.updateURL()
          this.updateVariantInput()
          this.renderProductInfo()
          this.renderFeaturedReviews()
          this.updateShareUrl()
        }
      }

      showOrHideInputs() {
        const productFormTop = this.productForm.offsetTop
        const isActive = this.productForm.classList.contains('active')
        let hideCount = 0

        function isOnTopLine(element) {
          const elementTop = element.offsetTop
          return elementTop - productFormTop < 15
        }

        this.selectors.forEach((selector) => {
          if (!isActive && !isOnTopLine(selector)) {
            selector.style.display = 'none'
            hideCount++
          } else {
            selector.style.display = 'block'
          }
        })

        if (!isActive) {
          if (hideCount === 0) {
            this.showMoreButton.style.display = 'none'
          } else {
            this.showMoreButton.style.display = 'block'
            if (!isOnTopLine(this.showMoreButton)) {
              // get last input still visible
              const lastVisibleInput = [...this.selectors]
                .reverse()
                .find((selector) => selector.style.display === 'block')
              if (lastVisibleInput) {
                lastVisibleInput.style.display = 'none'
              }
            }
          }
        }

        this.productForm.classList.remove('max-h-6.25', 'opacity-0')
      }

      setupShowMoreButton() {
        // Initialize show more button
        this.showMoreButton = this.querySelector('.js-show-more-variants')
        this.productForm = this.querySelector('.product-form__input')

        this.showMoreButton.addEventListener('click', this.toggleMoreVariants.bind(this))
        this.selectors = this.productForm.querySelectorAll('input[type="radio"].swatch-radio, label')

        this.showOrHideInputs()
      }

      updateMedia() {
        if (!this.currentVariant.featured_image) return
        const activeMedia = this.closest('.product-card').querySelector('.product-card__variant-image.active')

        const newMedia = this.closest('.product-card').querySelector(
          `[data-media-id="${this.dataset.section}-${this.currentVariant.featured_image.id}"]`
        )

        if (!newMedia) return

        activeMedia.classList.remove('active')
        newMedia.classList.add('active')
      }

      updateOptions() {
        const fieldsets = Array.from(this.querySelectorAll('fieldset'))
        this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
        })
      }

      updateVariantInfo() {
        const variantTitle = this.querySelector('.js-quickbuy-variant-title')
        const metafield = variantTitle.getAttribute('metafield')
        if (metafield) {
          const variantNew = document.querySelector(`[data-product-form-id=${this.dataset.productFormId}`)
          const newSpan = variantNew.querySelector('.js-quickbuy-new')
          if (metafield.includes(this.currentVariant.title.toLowerCase()) && this.currentVariant.title !== 'Chill') {
            newSpan.innerHTML = '&nbsp;*(NEW)'
          } else {
            newSpan.innerHTML = ''
          }
        }
        variantTitle.innerHTML = this.currentVariant.title
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(`#${this.dataset.productFormId}, #product-form-installment`)

        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]')

          input.value = this.currentVariant.id
          input.dispatchEvent(new Event('change', { bubbles: true }))
        })

        this.updateVariantInfo()
        this.updateMedia()
      }

      toggleMoreVariants({ target }) {
        target.closest('.options')?.querySelector('fieldset')?.classList.toggle('active')
        this.showOrHideInputs()
      }

      renderProductInfo() {
        const requestedVariantId = this.currentVariant.id
        const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section

        const queryChar = this.dataset.url.includes('?') ? '&' : '?'

        let fetchUrl = `${this.dataset.url}${queryChar}variant=${requestedVariantId}&section_id=main-product`
        if (fetchUrl.includes('-metafield')) {
          fetchUrl = fetchUrl.split('-metafield')[0]
        }
        fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => {
            // prevent unnecessary ui changes from abandoned selections
            if (this.currentVariant.id !== requestedVariantId) return

            const html = new DOMParser().parseFromString(responseText, 'text/html')
            const destination = this.closest('.product-card').querySelector('.price__container')
            const productForm = html.querySelector('#' + this.dataset.productFormId)
            const source = html.querySelector('.price__container')

            if (source && destination) destination.innerHTML = source.innerHTML

            // const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
            const addButtonUpdated = html.querySelector(`[id^=ProductSubmitButton-`)

            this.toggleAddButton(
              addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
              window.variantStrings.soldOut
            )

            const productBundle = this.closest('.product-bundle-variant-picker')
            if (productBundle) {
              const mediaDestination = document.querySelector('[id^=MediaGallery]')
              const mediaSource = html.querySelector('[id^=MediaGallery]')
              if (mediaSource && mediaDestination) {
                mediaDestination.innerHTML = mediaSource.innerHTML
                mediaDestination.init()
              }
            }
          })
      }

      toggleAddButton(disable = true, text, modifyClass = true) {
        const productForm = document.getElementById(this.dataset.productFormId)
        if (!productForm) return
        const addButton = productForm.querySelector('[name="add"]')

        const addButtonText = productForm.querySelector('[name="add"] > span')
        if (!addButton) return

        if (disable) {
          addButton.setAttribute('disabled', 'disabled')
          if (text) addButtonText.textContent = text + ' — '
        } else {
          addButton.removeAttribute('disabled')
          addButtonText.textContent = window.variantStrings.addToCart + ' — '
        }

        if (!modifyClass) return
      }
    }
  )
}
